import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { type ReactElement, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { ChannelAvatar } from '../../components/ChannelAvatar';
import { SectionHeader } from '../../components/SectionHeader';

// dir="auto": an affiliate name in Arabic or Hebrew keeps its own direction (C3 R7).
const OWN_DIRECTION = 'auto';

/** "Invited by" (S8 R13): the affiliate's display name only, never anything else (I8). */
export function InvitedBySection({ name }: { readonly name: string }): ReactElement {
  const { t } = useTranslation();
  const headingId = useId();
  return (
    <Box component="section" aria-labelledby={headingId}>
      <SectionHeader id={headingId} title={t('account.invitedBy.heading')} />
      <Paper
        variant="outlined"
        sx={{ p: 2, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <ChannelAvatar seed={name} name={name} size={36} />
        <Typography
          dir={OWN_DIRECTION}
          sx={{ fontWeight: 600, minWidth: 0, overflowWrap: 'anywhere' }}
        >
          {name}
        </Typography>
      </Paper>
    </Box>
  );
}
